import MessageStorage from '../storage/message-storage';

export default function reducer(state = new MessageStorage(), action) {
  switch (action.type) {
    case 'SET_ERROR_PAGE': {
      let newState = new MessageStorage();
      newState.errorMsg = action.text;
      return newState;
    }
    case 'SHOW_MESSAGE': {
      let newState = new MessageStorage();
      newState.open(action.payload.htmlId, action.payload.identifier, action.payload.text);
      return newState;
    }
    case 'SHOW_WARNING_MESSAGE': {
      let newState = new MessageStorage();
      newState.openWarning(action.payload.htmlId, action.payload.identifier, action.payload.text, action.payload.width, action.payload.top);
      return newState;
    }
    case 'CLOSE_MESSAGE': {
      let newState = new MessageStorage();
      newState.close();
      return newState;
    }
    case 'FILE_MESSAGE': {
      let newState = new MessageStorage(state.status);
      newState.fileMessage(action.payload);
      return newState;
    }
    default: return state;
  }
}
